import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import HeaderComponent from "./Home/HeaderComponent";
import Footer from "./Home/Footer";

const WHATSAPP_COMMUNITY_LINK = "https://chat.whatsapp.com/FYhRGAKRuLW8lxqkAY9Qb6";

const SLOT_LABELS = {
  "05:00": "5:00 AM",
  "07:30": "7:30 AM",
  "10:00": "10:00 AM",
};

export default function BookingSuccess() {
  const { state } = useLocation();
  const navigate = useNavigate();

  const { order_number, service_name, booking_date, slot } = state || {};

  const formatDate = (d) => {
    if (!d) return "";
    return new Date(d).toLocaleDateString("en-IN", {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  const details = [
    order_number && { label: "Order No.", value: order_number, highlight: true },
    service_name && { label: "Service", value: service_name },
    booking_date && { label: "Date", value: formatDate(booking_date) },
    slot && { label: "Slot", value: SLOT_LABELS[slot] || slot },
  ].filter(Boolean);

  return (
    <>
      <HeaderComponent />
      <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-red-50 flex flex-col items-center justify-center px-4 py-12">

      {/* Success Icon */}
      <div
        style={{
          width: 88,
          height: 88,
          borderRadius: "50%",
          background: "linear-gradient(135deg, #f97316, #ef4444)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: 24,
          boxShadow: "0 8px 24px rgba(249,115,22,0.35)",
        }}
      >
        <svg width="44" height="44" fill="none" viewBox="0 0 24 24" stroke="#fff" strokeWidth={2.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
        </svg>
      </div>

      {/* Title */}
      <h1 className="text-3xl font-bold text-gray-800 mb-2">Booking Confirmed!</h1>
      <p className="text-gray-500 mb-8 text-center max-w-xs">
        Your puja has been successfully booked. We will be in touch.
      </p>

      {/* Booking Details Card */}
      {details.length > 0 && (
        <div
          style={{
            width: "100%",
            maxWidth: 460,
            marginBottom: 20,
            background: "#fff",
            borderRadius: 20,
            boxShadow: "0 8px 32px rgba(249,115,22,0.10)",
            border: "1px solid #fed7aa",
            overflow: "hidden",
          }}
        >
          {/* Card header */}
          <div
            style={{
              background: "linear-gradient(to right, #f97316, #ef4444)",
              padding: "14px 20px",
            }}
          >
            <p className="text-white font-semibold text-sm uppercase tracking-widest">
              Booking Details
            </p>
          </div>

          {/* Detail rows */}
          <div style={{ padding: "4px 0" }}>
            {details.map(({ label, value, highlight }, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  padding: "12px 20px",
                  borderBottom: i < details.length - 1 ? "1px solid #fff7ed" : "none",
                }}
              >
                <span style={{ color: "#9ca3af", fontSize: 13, flexShrink: 0, marginRight: 12 }}>
                  {label}
                </span>
                <span
                  style={{
                    fontWeight: 600,
                    fontSize: 13,
                    color: highlight ? "#f97316" : "#1f2937",
                    textAlign: "right",
                    wordBreak: "break-word",
                    maxWidth: "60%",
                  }}
                >
                  {value}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* WhatsApp Community Card */}
      <div
        style={{
          width: "100%",
          maxWidth: 460,
          marginBottom: 32,
          textAlign: "center",
          background: "#fff",
          borderRadius: 20,
          boxShadow: "0 8px 32px rgba(249,115,22,0.10)",
          border: "1px solid #fed7aa",
          padding: "24px 20px",
        }}
      >
        <div style={{ marginBottom: 10 }}>
          <svg viewBox="0 0 24 24" width={52} height={52} fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="24" height="24" rx="6" fill="#25D366" />
            <path d="M12 4.5C7.86 4.5 4.5 7.86 4.5 12c0 1.34.35 2.6.96 3.7L4.5 19.5l3.93-.94A7.46 7.46 0 0012 19.5c4.14 0 7.5-3.36 7.5-7.5S16.14 4.5 12 4.5zm3.47 10.27c-.15.43-.88.82-1.21.87-.3.04-.68.06-1.1-.07-.25-.08-.58-.19-.99-.38-1.74-.75-2.88-2.5-2.97-2.62-.09-.12-.72-.96-.72-1.83 0-.87.46-1.3.62-1.47.16-.18.35-.22.47-.22l.34.01c.11 0 .25-.04.4.3.15.35.5 1.22.55 1.31.04.09.07.2.01.32-.06.12-.09.19-.18.3-.09.1-.19.23-.27.31-.09.09-.18.18-.08.36.1.18.46.75.98 1.21.67.6 1.24.79 1.42.88.18.09.28.07.38-.04.1-.12.44-.51.55-.69.12-.18.23-.15.39-.09.16.06 1.02.48 1.2.57.17.09.29.13.33.2.04.08.04.44-.11.87z" fill="#fff" />
          </svg>
        </div>
        <p className="font-bold text-gray-800 mb-1" style={{ fontSize: 16 }}>
          Join Our WhatsApp Community
        </p>
        <p className="text-gray-500 text-sm mb-5">
          Stay updated on upcoming pujas, events and temple news.
        </p>
        <a
          href={WHATSAPP_COMMUNITY_LINK}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            backgroundColor: "#25d366",
            color: "#fff",
            fontWeight: 600,
            padding: "12px 28px",
            borderRadius: 12,
            textDecoration: "none",
            fontSize: 15,
            boxShadow: "0 4px 12px rgba(37,211,102,0.3)",
          }}
        >
          <svg viewBox="0 0 24 24" width={20} height={20} fill="none">
            <rect width="24" height="24" rx="5" fill="rgba(255,255,255,0.25)" />
            <path d="M12 4.5C7.86 4.5 4.5 7.86 4.5 12c0 1.34.35 2.6.96 3.7L4.5 19.5l3.93-.94A7.46 7.46 0 0012 19.5c4.14 0 7.5-3.36 7.5-7.5S16.14 4.5 12 4.5zm3.47 10.27c-.15.43-.88.82-1.21.87-.3.04-.68.06-1.1-.07-.25-.08-.58-.19-.99-.38-1.74-.75-2.88-2.5-2.97-2.62-.09-.12-.72-.96-.72-1.83 0-.87.46-1.3.62-1.47.16-.18.35-.22.47-.22l.34.01c.11 0 .25-.04.4.3.15.35.5 1.22.55 1.31.04.09.07.2.01.32-.06.12-.09.19-.18.3-.09.1-.19.23-.27.31-.09.09-.18.18-.08.36.1.18.46.75.98 1.21.67.6 1.24.79 1.42.88.18.09.28.07.38-.04.1-.12.44-.51.55-.69.12-.18.23-.15.39-.09.16.06 1.02.48 1.2.57.17.09.29.13.33.2.04.08.04.44-.11.87z" fill="#fff" />
          </svg>
          Join Community
        </a>
      </div>

      {/* Bottom actions */}
      <div style={{ display: "flex", gap: 24, alignItems: "center" }}>
        <button
          onClick={() => navigate("/services")}
          style={{
            background: "linear-gradient(to right, #f97316, #ef4444)",
            color: "#fff",
            fontWeight: 600,
            padding: "10px 24px",
            borderRadius: 10,
            border: "none",
            cursor: "pointer",
            fontSize: 14,
            boxShadow: "0 4px 12px rgba(249,115,22,0.3)",
          }}
        >
          Book Another Service
        </button>
        <button
          onClick={() => navigate("/")}
          style={{
            color: "#f97316",
            fontWeight: 600,
            background: "none",
            border: "none",
            cursor: "pointer",
            fontSize: 14,
            textDecoration: "underline",
          }}
        >
          Go to Home
        </button>
      </div>
    </div>
      <Footer />
    </>
  );
}
